<template>
  <div>
    <b-nav-item-dropdown right :class="classes"
      style="margin-right: 10px !important; padding-left: 20px !important; padding-right: 10px !important;">
      <template slot="button-content">
        <div v-if="!state.active" class="printer-status mb-3" style="max-width: 300px;">
          <strong>
            Download Print<br>Driver - Optional
          </strong>
          <!-- <i :class="dotClass"></i> -->
        </div>
        <img class="printer-icon"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALOSURBVGhD7ZjNaxNBGMb3PxAE/wmv4s1SxLrZJAfBevKmUmPVi6gUpAc92N1NrDbBjyIpmxYRvWhsRfBgiR/ZmegGBWtCVYRYPaiRVisN1eyO8yaTJpFBJYRklu4DzyHwzr6/h2TenYy07uQPo9ldo5knnTT0ZO3bJ5+GiD79hkykCh0x9IKerH37BA+dW/hOOiXo5QX5m7wgLcoL8i95QVpU24MoGtoGD+xWEDAwMJzW5cogylm8eadqHpNH0NCaNXSl9sDY/XfkJvrYEUOvWl9gaGQCRmBl2M1SdDREF9n9Uau0Lz630ugDE6/KA0aOhBKdNfSE3n/yACOw+nR8kuFXpejpHT4d2bFUkdx767jC0YdFAsyyjrezGDCRzBtHpvJl3gKRDcx0/1xnMSQpEMaZ4WSBWyyyT88skGA4g1mMSpCnbgxy5u4HAuwsBj9Ict4ht/K2UAamRsb/CmK8sMm4JZaBqZHRC9Jte0F4D+um10cQ+pov1g5nrjXNQL+NDDp67TUZTy+60sAeiGSQJKvmpUOJvNP4lbnJISPnyJp5EY7vh/tjWZtX5AYDu6yiQRrE7KUnSDI9X+YWiuwZylzdI7iH/it8tAk+TFo/uMUiO2EtV4LIo+bGyuTyh/HShdnP3GKRfZ4y0/H7tRICBLt+OPmeWyyy4d1Hp+5jFkOqTa5fvGKRHTLyPyl7lMWAIGhwTzRb4hWL7N1jVklW8UEWAy4fzF66aRw3Ta47lYllOk13XmuTK7vMXSSijWfVidWnWRtYjKr8Ol500+Q69+ATodP2C8OvKxDBppsm16nbBRKM4BTDr4ueV8YGjNwqb5GI3h9/uUqHlM7w6/KpZp+i4XIcf+MuFMlX0RJcbMOVaQ/Db1ZQxzF6iLT3Xn7edNcqkoHNpyLHr6MIw+ZLGUlvlTV8go42TUTTn9Nx+u7YwnA9efLkyVM3JUm/AXkT3UunOY/jAAAAAElFTkSuQmCC">
        {{ activePrinter | truncate(6) }}
      </template>

      <b-dropdown-item v-if="state.active" v-for="printer in printers" v-bind:key="printer"
        :active="activePrinter === printer" @click="onClickPrinter(printer)">{{ printer }} <span
          v-if="activePrinter === printer"><i class="fa fa-check-square-o" aria-hidden="true"></i></span>
      </b-dropdown-item>

      <!-- <b-dropdown-item
      class="active text-center"
      v-if="state.active"
      @click="onClickTest()"
    >Print test label</b-dropdown-item> -->
      <b-dropdown-item v-if="!state.active" href="https://qz.io/download/" target="_blank">Download Printer Driver - QZ
        Tray
      </b-dropdown-item>
      <b-dropdown-item v-if="!state.active && !state.waiting" @click="restartConnection()">Retry Connection (If
        downloaded)
      </b-dropdown-item>
      <b-dropdown-item v-if="!state.active && !state.waiting" @click="$bvModal.show('modal_printerDemo')">What does this
        driver do?

      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-modal id="modal_printerDemo" size="xl" hide-footer hide-header>
      <div style="background-color: #29286c;  margin-top: -12px" class="row">
        <div class="mx-auto col-12" align="center">
          <h5 style="color: white" class="mt-2">Print Driver - Optional</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-5" style="font-size: 20px">
          <p>
            By downloading the Print Driver – QZ Tray, GrandShipper will print directly to your available printers whether
            it is a traditional inkjet or a thermal printer.
          </p>
          <p>
            If you choose not to, you can still create shipping labels where GrandShipper will utilize your browser’s
            built-in Print Function (photo to the right as an example).
          </p>
        </div>
        <div class="col-6 mt-5">
          <b-img src="/images/print_preview/printingBrowserFunction.png" fluid alt="Responsive image"></b-img>
        </div>
      </div>
      <b-button id="modalcloseBtn" class="mt-3 pull-right" @click="$bvModal.hide('modal_printerDemo')">Close</b-button>
    </b-modal>
  </div>
</template>

<style lang="scss">
.dropdown-item.active span {
  position: absolute;
  right: 0;

  i {
    color: #212529;
  }
}

#modalcloseBtn {
  font-size: 15px !important;
}

.app-header.navbar {
  .nav-item.printer-service {
    margin-left: .5rem !important;
    position: relative;
    background-color: #bdea74;
    min-width: 100px;

    // &:not(.inactive) {
    //   top: 4px;
    // }

    .nav-link {
      font-size: 0.80rem;
    }

    .printer-icon {
      width: 20px;
      margin-right: 3px;
    }

    a.dropdown-toggle {
      color: #434343 !important;
      font-size: 0.80rem;
    }

    &.inactive {
      padding: 0;
      background: transparent;
      margin-left: 0 !important;

      .printer-icon {
        display: none;
      }

      a.dropdown-toggle {
        font-size: 0;
        margin-left: 0;
      }

      .printer-status {
        position: static;
        padding-right: 0;
        font-size: 0.75rem;
      }
    }

    .printer-status {
      position: absolute;
      top: -18px;
      // right: 100%;
      // bottom: 0;
      pointer-events: none;
      color: #fff;
      font-size: 0.75rem;
      height: 1.5em;
      margin: auto;
      padding-right: 15px;
    }
  }
}
</style>

<script>
import Axios from 'axios';
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      states: {
        waiting: {
          active: false,
          waiting: true,
          class: "text-warning"
        },
        connected: {
          active: true,
          class: "text-success"
        },
        inactive: {
          active: false,
          class: "text-danger"
        },
        error: {
          active: false,
          class: "text-danger"
        }
      },
      state: {
        active: false,
        class: "text-danger"
      },
      printers: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    activePrinter() {
      return this.$store.getters.getDefaultPrinter || "Select printer";
    },
    classes() {
      let classes = "printer-service px-2 rounded-pill";
      if (!this.state.active) {
        classes += " inactive";
      }
      return classes;
    },
    dotClass() {
      if (this.state && this.state.class) {
        return "fa fa-circle " + this.state.class;
      } else {
        return "fa fa-circle";
      }
    },
    qzConfig() {
      return {};
    }
  },
  created() {
    qz.websocket.setClosedCallbacks(this.onConnectClosed);
  },
  mounted() {
    this.startConnection(this.qzConfig);
  },
  methods: {
    ...mapActions(["setDefaultPrinter", "addPrintJob"]),
    savePrinter(printer) {
      axios.post('/user/printer', { printer: printer });
    },
    updateState(state) {
      console.log("Updating state to " + state);
      this.state = { ...state };
    },
    displayMessage(message) {
      console.log(message);
    },
    displayError(message) {
      console.log(message);
    },
    startConnection(config) {
      if (!qz.websocket.isActive()) {
        this.updateState(this.states.waiting);

        qz.websocket
          .connect(config)
          .then(() => {
            this.updateState(this.states.connected);
            this.findPrinters();
          })
          .catch(err => {
            this.handleConnectionError(err);
          });
      } else {
        this.displayMessage(
          "An active connection with QZ already exists.",
          "alert-warning"
        );
      }
    },
    endConnection() {
      if (qz.websocket.isActive()) {
        qz.websocket
          .disconnect()
          .then(function () {
            this.updateState(this.states.inactive);
          })
          .catch(this.handleConnectionError);
      } else {
        qz.websocket.disconnect();
        this.displayMessage(
          "No active connection with QZ exists.",
          "alert-warning"
        );
      }
    },
    restartConnection() {
      if (qz.websocket.isActive()) {
        qz.websocket
          .disconnect()
          .then(function () {
            this.updateState(this.states.inactive);
            this.startConnection();
          })
          .catch(this.handleConnectionError);
      } else {
        this.startConnection();
      }
    },
    printerDriverModal() {

    },
    onConnectClosed(e) {
      this.updateState(this.states.inactive);
    },
    handleConnectionError(err) {
      this.updateState(this.states.inactive);

      if (err.target != undefined) {
        if (err.target.readyState >= 2) {
          //if CLOSING or CLOSED
          this.displayError("Connection to QZ Tray was closed");
        } else {
          this.updateState(this.states.error);
          this.displayError(
            "A connection error occurred, check log for details"
          );
        }
      } else {
        this.displayError(err);
      }
    },
    findPrinters() {
      // qz.printers.details().then(details => {
      //   console.log('Printer details', details);
      // })
      qz.printers.find().then(printers => {
        this.printers = printers;
        console.log('Printers', printers);

        const default_printer = this.user.default_printer;

        if (printers.includes(default_printer)) {
          this.setDefaultPrinter(default_printer);
        } else if (printers.length > 0) {
          this.savePrinter(printers[0]);
          this.setDefaultPrinter(printers[0]);
        }
      });
    },
    onClickPrinter(printer) {
      this.activePrinter = printer;
      this.savePrinter(printer);
      this.setDefaultPrinter(printer);
    },
    onClickTest() {
      axios.post("/printlabel/test").then(response => {
        const decoded = response.data;

        this.addPrintJob({
          label: decoded.label,
          label_url: decoded.label_url,
          type: "b64"
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header/HeaderPrintService.vue